import { setupEntryPoint } from './setupEntryPoint'
import App from '@/layouts/LobbyLayout.vue'
import router from '@/routers/lobby'

setupEntryPoint(App, router)
